import { render, staticRenderFns } from "./choosetactics.vue?vue&type=template&id=33d21b3f&scoped=true"
import script from "./choosetactics.vue?vue&type=script&lang=js"
export * from "./choosetactics.vue?vue&type=script&lang=js"
import style0 from "./choosetactics.vue?vue&type=style&index=0&id=33d21b3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d21b3f",
  null
  
)

export default component.exports